import PatientsIcon from '@mui/icons-material/PeopleOutlineOutlined';
import TriageIcon from '@mui/icons-material/ListOutlined';
import UsersIcon from '@mui/icons-material/SupervisedUserCircleOutlined';
import DischargeUsersIcon from '@mui/icons-material/PeopleAlt';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ReportsIcon from '@mui/icons-material/TableChartOutlined';
import {
    ChatIcon,
    DailyAssessmentIconBadge,
    WeeklyAssessmentIconBadge,
    ExerciseSkippedBadge,
    SuitabilityBadge,
    ExerciseFeedbackBadge,
    AdherenceBadge,
    SharedNotesIconBadge
} from 'components/IconBadge';
import LogIcon from '@mui/icons-material/ViewListOutlined';
import AdherenceIcon from '@mui/icons-material/CardMembershipTwoTone';
import ProgrammesIcon from '@mui/icons-material/Pages';
import { WavingHand } from '@mui/icons-material';
import {
    EventNoteOutlined,
    PlaylistRemoveOutlined,
    Diversity1Outlined,
    AlarmOutlined,
    FireExtinguisherOutlined
} from '@mui/icons-material';

export const PackageRoutes = (
    isPlusAgent?: boolean,
    isPhioTriageAgent?: boolean
): { [propName: string]: any } => {
    return {
        user_management: {
            name: 'User Management',
            order: 5,
            routes: [
                {
                    path: '/dashboard/users',
                    routeName: 'Users',
                    exact: true,
                    icon: UsersIcon
                },
                {
                    path: '/dashboard/audit-logs',
                    routeName: 'Audit Log',
                    exact: true,
                    icon: LogIcon
                }
            ]
        },
        engage_management: {
            name: 'Engage',
            order: 2,
            routes: [
                {
                    path: '/dashboard/adherence',
                    exact: true,
                    routeName: 'Adherence',
                    icon: AdherenceBadge
                },
                {
                    path: '/dashboard/suitable-for-treatment',
                    exact: true,
                    routeName: 'Suitability',
                    icon: SuitabilityBadge
                },
                {
                    path: '/dashboard/patients',
                    exact: true,
                    routeName: 'Patients',
                    icon: PatientsIcon
                },
                {
                    path: '/dashboard/daily_assessment',
                    routeName: 'Daily Assessment',
                    icon: DailyAssessmentIconBadge
                },
                {
                    path: '/dashboard/weekly_assessment',
                    routeName: 'Weekly Assessment',
                    icon: WeeklyAssessmentIconBadge
                },
                {
                    path: '/dashboard/skipped_feedback',
                    routeName: 'Skipped Feedback',
                    icon: ExerciseSkippedBadge
                },
                {
                    path: '/dashboard/session_feedback',
                    routeName: 'Session Feedback',
                    icon: ExerciseFeedbackBadge
                },
                {
                    path: '/dashboard/support',
                    exact: true,
                    routeName: 'Support',
                    icon: ChatIcon
                }
            ]
        },
        engage_v2: {
            name: 'Engage v2',
            order: 3,
            routes: [
                {
                    path: '/dashboard/phioengage-profiles',
                    exact: true,
                    routeName: 'Enrolled Patients',
                    icon: Diversity1Outlined
                },
                {
                    path: '/dashboard/phioengage-worklist',
                    exact: true,
                    routeName: 'Clinical Worklist',
                    icon: EventNoteOutlined
                },
                {
                    path: '/dashboard/phioengage-discharged',
                    exact: true,
                    routeName: 'Discharged Patients',
                    icon: PlaylistRemoveOutlined
                }
            ]
        },
        access_management: {
            order: 1,
            name: 'Access',
            routes:
                isPlusAgent || isPhioTriageAgent
                    ? [
                          {
                              path: '/dashboard/access/triage',
                              exact: true,
                              routeName: 'Triages',
                              icon: AdherenceIcon
                          },
                          {
                              path: '/dashboard/access/patient',
                              exact: true,
                              routeName: 'Patient List',
                              icon: PatientsIcon
                          },
                          {
                              path: '/dashboard/access/about-this-portal',
                              routeName: 'About This Portal',
                              icon: InfoOutlinedIcon
                          }
                      ]
                    : [
                          {
                              path: '/dashboard/access/triage',
                              exact: true,
                              routeName: 'Triages',
                              icon: AdherenceIcon
                          },
                          {
                              path: '/dashboard/access/patient',
                              exact: true,
                              routeName: 'Patient List',
                              icon: PatientsIcon
                          }
                      ]
        },
        workflow: {
            order: 4,
            name: 'Workflow',
            routes: [
                {
                    path: '/dashboard/phio_access',
                    routeName: 'Triage List',
                    icon: TriageIcon
                },
                {
                    path: '/dashboard/discharged_from_engage',
                    routeName: 'Discharged List',
                    icon: DischargeUsersIcon
                },
                {
                    path: '/dashboard/shared_notes',
                    routeName: 'Shared Notes',
                    icon: SharedNotesIconBadge
                }
            ]
        },
        product_configuration: {
            order: 8,
            name: 'Configuration',
            routes: [
                {
                    path: '/dashboard/programmes',
                    routeName: 'Programmes',
                    icon: ProgrammesIcon
                },
                {
                    path: '/dashboard/phio-engage-configuration',
                    routeName: 'v2 Config',
                    icon: InfoOutlinedIcon
                },
                {
                    path: '/dashboard/phio-engage-discharge-configuration',
                    routeName: 'Discharge Config',
                    icon: WavingHand
                }
            ]
        },
        // customer_support: {
        //     name: 'Customer Support',
        //     routes: [
        //     ]
        // },
        management_information: {
            order: 6,
            name: 'Management Info',
            routes: [
                {
                    path: '/dashboard/reports',
                    routeName: 'Reports',
                    icon: ReportsIcon
                }
            ]
        },
        collect_management: {
            order: 7,
            name: 'Collect',
            routes: [
                {
                    path: '/dashboard/collect',
                    routeName: 'Collections',
                    icon: UsersIcon
                }
            ]
        },
        support: {
            order: 9,
            name: 'Inactivity Reminders',
            routes: [
                {
                    path: '/dashboard/inactivity-reminders-queue',
                    routeName: 'Inactivity Reminders',
                    icon: AlarmOutlined
                },
                {
                    path: '/dashboard/autodischarge-queue',
                    routeName: 'Autodischarge Queue',
                    icon: FireExtinguisherOutlined
                }
            ]
        }
    };
};
